import React, { useState } from "react";

const questions = [
    {
        question: "Che cosa significa HTML?",
        options: ["HyperText Markup Language", "High Tech Modern Language", "Home Tool Markup Language"],
        correct: 0
    },
    {
        question: "Quale linguaggio è usato per lo styling?",
        options: ["JavaScript", "CSS", "Python"],
        correct: 1
    },
    {
        question: "Qual è il framework React creato da?",
        options: ["Google", "Facebook", "Microsoft"],
        correct: 1
    },
    {
        question: "Cosa significa API?",
        options: ["Application Programming Interface", "Automated Program Integration", "Advanced Programming Index"],
        correct: 0
    },
    {
        question: "Qual è il linguaggio di scripting del web?",
        options: ["Java", "JavaScript", "Python"],
        correct: 1
    }
];

export default function QuizGame() {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [score, setScore] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [started, setStarted] = useState(false);

    const handleAnswer = (index) => {
        setSelectedAnswer(index);
        if (index === questions[currentQuestion].correct) {
            setScore(score + 1);
        }

        setTimeout(() => {
            if (currentQuestion + 1 < questions.length) {
                setCurrentQuestion(currentQuestion + 1);
                setSelectedAnswer(null);
            } else {
                setShowResult(true);
            }
        }, 1000);
    };

    const restart = () => {
        setCurrentQuestion(0);
        setScore(0);
        setShowResult(false);
        setSelectedAnswer(null);
        setStarted(false);
    };

    if (!started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-question-circle" style={{marginRight:"6px"}}></i> Quiz Tech
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>Rispondi a 5 domande di cultura tech!</p>
                <button
                    onClick={() => setStarted(true)}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia Quiz
                </button>
            </div>
        );
    }

    if (showResult) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Quiz Completato!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    {score}/{questions.length}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score === questions.length && "🎉 Perfetto! Sei un vero esperto!"}
                    {score >= 3 && score < questions.length && "👍 Ottimo lavoro!"}
                    {score < 3 && "💪 Continua a studiare!"}
                </p>
                <button
                    onClick={restart}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Riprova
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{marginBottom:"1rem", color:"#94a3b8", fontSize:"0.85rem"}}>
                Domanda {currentQuestion + 1} di {questions.length}
            </div>
            <h4 style={{color:"#facc15", marginBottom:"1.5rem", fontSize:"1rem", lineHeight:"1.4"}}>
                {questions[currentQuestion].question}
            </h4>
            <div style={{display:"flex", flexDirection:"column", gap:"0.8rem"}}>
                {questions[currentQuestion].options.map((option, index) => {
                    const isSelected = selectedAnswer === index;
                    const isCorrect = index === questions[currentQuestion].correct;
                    const showFeedback = selectedAnswer !== null;

                    return (
                        <button
                            key={index}
                            onClick={() => selectedAnswer === null && handleAnswer(index)}
                            disabled={selectedAnswer !== null}
                            style={{
                                padding:"0.8rem",
                                borderRadius:"0.5rem",
                                border: showFeedback
                                    ? (isCorrect ? "2px solid #22c55e" : isSelected ? "2px solid #ef4444" : "1px solid rgba(255,255,255,0.1)")
                                    : "1px solid rgba(255,255,255,0.1)",
                                background: showFeedback
                                    ? (isCorrect ? "rgba(34,197,94,0.2)" : isSelected ? "rgba(239,68,68,0.2)" : "rgba(255,255,255,0.05)")
                                    : "rgba(255,255,255,0.05)",
                                color:"#fff",
                                cursor: selectedAnswer === null ? "pointer" : "default",
                                fontSize:"0.85rem",
                                transition:"all 0.3s ease",
                                textAlign:"left"
                            }}
                        >
                            {showFeedback && isCorrect && <i className="fas fa-check" style={{marginRight:"6px", color:"#22c55e"}}></i>}
                            {showFeedback && isSelected && !isCorrect && <i className="fas fa-times" style={{marginRight:"6px", color:"#ef4444"}}></i>}
                            {option}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}